/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ControlcenterMelcoControlCenterModelsLokaliseStringsSave,
    ControlcenterMelcoControlCenterModelsLokaliseStringsSaveFromJSON,
    ControlcenterMelcoControlCenterModelsLokaliseStringsSaveToJSON,
    ControlcenterMelcoModelsError,
    ControlcenterMelcoModelsErrorFromJSON,
    ControlcenterMelcoModelsErrorToJSON,
    ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsLokaliseModule,
    ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsLokaliseModuleFromJSON,
    ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsLokaliseModuleToJSON,
    ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsLokaliseString,
    ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsLokaliseStringFromJSON,
    ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsLokaliseStringToJSON,
} from '../models';

export interface LokaliseApiLokaliseGetStringsRequest {
    moduleId: string;
}

export interface LokaliseApiLokalisePublishRequest {
    moduleId: string;
}

export interface LokaliseApiLokaliseRevertRequest {
    moduleId: string;
}

export interface LokaliseApiLokaliseSaveDraftRequest {
    moduleId: string;
    controlcenterMelcoControlCenterModelsLokaliseStringsSave?: ControlcenterMelcoControlCenterModelsLokaliseStringsSave;
}

/**
 * 
 */
export class LokaliseApi extends runtime.BaseAPI {

    /**
     */
    async lokaliseGetModuleListRaw(): Promise<runtime.ApiResponse<ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsLokaliseModule>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/manage/lokalise/modules`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsLokaliseModuleFromJSON(jsonValue));
    }

    /**
     */
    async lokaliseGetModuleList(): Promise<ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsLokaliseModule> {
        const response = await this.lokaliseGetModuleListRaw();
        return await response.value();
    }

    /**
     */
    async lokaliseGetStringsRaw(requestParameters: LokaliseApiLokaliseGetStringsRequest): Promise<runtime.ApiResponse<ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsLokaliseString>> {
        if (requestParameters.moduleId === null || requestParameters.moduleId === undefined) {
            throw new runtime.RequiredError('moduleId','Required parameter requestParameters.moduleId was null or undefined when calling lokaliseGetStrings.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/manage/lokalise/modules/{module_id}/strings`.replace(`{${"module_id"}}`, encodeURIComponent(String(requestParameters.moduleId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsLokaliseStringFromJSON(jsonValue));
    }

    /**
     */
    async lokaliseGetStrings(requestParameters: LokaliseApiLokaliseGetStringsRequest): Promise<ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsLokaliseString> {
        const response = await this.lokaliseGetStringsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async lokalisePublishRaw(requestParameters: LokaliseApiLokalisePublishRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.moduleId === null || requestParameters.moduleId === undefined) {
            throw new runtime.RequiredError('moduleId','Required parameter requestParameters.moduleId was null or undefined when calling lokalisePublish.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/manage/lokalise/modules/{module_id}/strings/publish`.replace(`{${"module_id"}}`, encodeURIComponent(String(requestParameters.moduleId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async lokalisePublish(requestParameters: LokaliseApiLokalisePublishRequest): Promise<void> {
        await this.lokalisePublishRaw(requestParameters);
    }

    /**
     */
    async lokaliseRevertRaw(requestParameters: LokaliseApiLokaliseRevertRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.moduleId === null || requestParameters.moduleId === undefined) {
            throw new runtime.RequiredError('moduleId','Required parameter requestParameters.moduleId was null or undefined when calling lokaliseRevert.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/manage/lokalise/modules/{module_id}/strings`.replace(`{${"module_id"}}`, encodeURIComponent(String(requestParameters.moduleId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async lokaliseRevert(requestParameters: LokaliseApiLokaliseRevertRequest): Promise<void> {
        await this.lokaliseRevertRaw(requestParameters);
    }

    /**
     */
    async lokaliseSaveDraftRaw(requestParameters: LokaliseApiLokaliseSaveDraftRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.moduleId === null || requestParameters.moduleId === undefined) {
            throw new runtime.RequiredError('moduleId','Required parameter requestParameters.moduleId was null or undefined when calling lokaliseSaveDraft.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/manage/lokalise/modules/{module_id}/strings`.replace(`{${"module_id"}}`, encodeURIComponent(String(requestParameters.moduleId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ControlcenterMelcoControlCenterModelsLokaliseStringsSaveToJSON(requestParameters.controlcenterMelcoControlCenterModelsLokaliseStringsSave),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async lokaliseSaveDraft(requestParameters: LokaliseApiLokaliseSaveDraftRequest): Promise<void> {
        await this.lokaliseSaveDraftRaw(requestParameters);
    }

}
